const mutations = {
  setShopCategories: (state, data) => {
    state.shopCategories = data;
  },
  setShopTypes: (state, data) => {
    state.shopTypes = data;
  },
  setShopLocations: (state, data) => {
    state.shopLocations = data;
  },
  setProductCategories: (state, data) => {
    state.productCategories = data;
  },
  setUserList: (state, data) => {
    state.userList = data
  },
  setUserPageInfo: (state, data) => {
    state.userPageInfo = data
  },
  setStoreAccounts: (state, accounts) => {
    state.storeAccounts = accounts
  },
  setCheckedList: (state, checkedList = []) => {
    state.checkedList = checkedList
  }
};

export default mutations;
